(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-alygn"] && !Shopify.designMode) return;
  try {
    
  // Op mobiel starten alle panelen ingeklapt; op desktop blijven ze open.
  (function () {
    const MOBILE = '(max-width: 749px)';

    function sync(root) {
      const isMobile = window.matchMedia(MOBILE).matches;
      root.querySelectorAll('.footer-alygn__col').forEach((el) => {
        if (isMobile) {
          if (!el.dataset.faTouched) el.open = false;
        } else {
          el.open = true;
        }
      });
    }

    function init() {
      document.querySelectorAll('.footer-alygn').forEach((root) => {
        if (root.dataset.faInit) return;
        root.dataset.faInit = '1';

        root.querySelectorAll('.footer-alygn__col').forEach((el) => {
          el.addEventListener('toggle', () => {
            if (window.matchMedia(MOBILE).matches) el.dataset.faTouched = '1';
          });
        });

        sync(root);
        window.matchMedia(MOBILE).addEventListener('change', () => {
          root.querySelectorAll('.footer-alygn__col').forEach((el) => delete el.dataset.faTouched);
          sync(root);
        });
      });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klantbeoordelingen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alygn-swipe')) {
    class AlygnSwipe extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-swipe-track]');
        this.dots = this.querySelector('[data-swipe-dots]');
        if (!this.track || !this.dots) return;

        this.items = Array.from(this.track.children).filter(function (child) {
          return child.tagName === 'LI';
        });

        this.build();
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }

      build() {
        var self = this;
        this.dots.innerHTML = '';
        this.buttons = this.items.map(function (item, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = self.dataset.dotClass || 'alygn-swipe__dot';
          button.setAttribute('aria-label', 'Ga naar item ' + (index + 1));
          button.addEventListener('click', function () {
            self.track.scrollTo({ left: item.offsetLeft - self.track.offsetLeft, behavior: 'smooth' });
          });
          self.dots.appendChild(button);
          return button;
        });
      }

      onScroll() {
        var swipeable = this.track.scrollWidth - this.track.clientWidth > 8;
        this.dots.hidden = !swipeable || this.items.length < 2;
        if (this.dots.hidden) return;

        var center = this.track.scrollLeft + this.track.clientWidth / 2;
        var active = 0;
        var self = this;
        this.items.forEach(function (item, index) {
          var start = item.offsetLeft - self.track.offsetLeft;
          if (start <= center) active = index;
        });

        this.buttons.forEach(function (button, index) {
          button.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
      }
    }

    customElements.define('alygn-swipe', AlygnSwipe);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offerteformulier"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var aantal = params.get('aantal');
    var product = params.get('product');

    document.querySelectorAll('[data-offerte-form]').forEach(function (form) {
      if (aantal) {
        var select = form.querySelector('[data-aantal]');
        if (select) {
          var match = Array.from(select.options).find(function (option) {
            var numbers = option.value.match(/\d+/g);
            if (!numbers) return false;
            var low = parseInt(numbers[0], 10);
            var high = numbers[1] ? parseInt(numbers[1], 10) : Infinity;
            var value = parseInt(aantal, 10);
            return value >= low && value <= high;
          });
          if (match) select.value = match.value;
        }

        var opmerking = form.querySelector('textarea');
        if (opmerking && !opmerking.value) {
          opmerking.value = 'Via de rekentool: ' + aantal + ' werkplekken.';
        }
      }

      if (product) {
        var check = form.querySelector('[data-behoefte="' + product + '"]');
        if (check) check.checked = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rekentool-investering"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alygn-rekentool')) {
    class AlygnRekentool extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('[data-qty-range]');
        this.number = this.querySelector('[data-qty-number]');
        this.totalEl = this.querySelector('[data-total]');
        this.unitEl = this.querySelector('[data-unit]');
        this.cta = this.querySelector('[data-cta]');
        this.compareEl = this.querySelector('[data-compare]');
        this.savingEl = this.querySelector('[data-saving]');
        this.savingTextEl = this.querySelector('[data-saving-text]');
        if (this.savingEl) this.savingEl.dataset.template = this.dataset.savingTemplate || 'Bespaar {procent}%';
        this.options = Array.from(this.querySelectorAll('[data-product-option]'));

        this.inclTax = this.dataset.inclTax === 'true';
        this.taxRate = parseFloat(this.dataset.taxRate || '21');
        this.rounding = parseInt(this.dataset.rounding || '1', 10);
        this.ctaHref = this.cta ? this.cta.getAttribute('href') : null;
        this.emptyLabel = this.dataset.emptyLabel || 'Prijs op aanvraag';

        try {
          const raw = this.querySelector('[data-tiers]');
          this.tiers = raw ? JSON.parse(raw.textContent) : [];
        } catch (error) {
          this.tiers = [];
        }
        this.tiers.sort((a, b) => a.min - b.min);

        this.formatter = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });

        this.onInput = this.onInput.bind(this);
        if (this.range) this.range.addEventListener('input', this.onInput);
        if (this.number) this.number.addEventListener('input', this.onInput);
        this.options.forEach((option) => option.addEventListener('change', this.onInput));

        this.render();
      }

      get quantity() {
        const min = parseInt(this.range.min, 10);
        const max = parseInt(this.range.max, 10);
        let value = parseInt(this.range.value, 10);
        if (Number.isNaN(value)) value = min;
        return Math.min(Math.max(value, min), max);
      }

      get selectedOption() {
        return this.options.find((option) => option.checked) || this.options[0];
      }

      get unitPriceCents() {
        const selected = this.selectedOption;
        return selected ? parseInt(selected.dataset.unitPrice, 10) || 0 : 0;
      }

      get comparePriceCents() {
        const selected = this.selectedOption;
        const value = selected ? parseInt(selected.dataset.comparePrice, 10) || 0 : 0;
        return Math.max(value, this.unitPriceCents);
      }

      discountFor(quantity) {
        let discount = 0;
        this.tiers.forEach((tier) => {
          if (quantity >= tier.min) discount = tier.discount;
        });
        return discount / 100;
      }

      onInput(event) {
        if (event.target === this.number) {
          const min = parseInt(this.range.min, 10);
          const max = parseInt(this.range.max, 10);
          let value = parseInt(this.number.value, 10);
          if (Number.isNaN(value)) return;
          value = Math.min(Math.max(value, min), max);
          this.range.value = value;
        }
        this.render();
      }

      render() {
        const quantity = this.quantity;
        this.range.value = quantity;
        if (document.activeElement !== this.number) this.number.value = quantity;

        const min = parseInt(this.range.min, 10);
        const max = parseInt(this.range.max, 10);
        const progress = max > min ? ((quantity - min) / (max - min)) * 100 : 0;
        this.range.style.setProperty('--rt-progress', progress + '%');

        const taxDivider = this.inclTax ? 1 + this.taxRate / 100 : 1;
        const listIncl = this.unitPriceCents / 100;
        const compareIncl = this.comparePriceCents / 100;
        const discount = this.discountFor(quantity);

        if (!listIncl) {
          this.totalEl.textContent = this.emptyLabel;
          if (this.unitEl) this.unitEl.textContent = '';
          if (this.compareEl) this.compareEl.hidden = true;
          if (this.savingEl) this.savingEl.hidden = true;
          return;
        }

        const unitIncl = listIncl * (1 - discount);
        const unitExcl = unitIncl / taxDivider;
        const compareExcl = compareIncl / taxDivider;

        let total = unitExcl * quantity;
        let compareTotal = compareExcl * quantity;
        if (this.rounding > 1) {
          total = Math.round(total / this.rounding) * this.rounding;
          compareTotal = Math.round(compareTotal / this.rounding) * this.rounding;
        }

        this.totalEl.textContent = this.formatter.format(total);

        if (this.unitEl) {
          const template = this.unitEl.dataset.template || 'Dat is {prijs} per werkplek';
          this.unitEl.textContent = template.replace('{prijs}', this.formatter.format(total / quantity));
        }

        const saving = compareIncl > 0 ? 1 - unitIncl / compareIncl : 0;
        const savingPercent = Math.round(saving * 100);

        if (this.compareEl) {
          if (savingPercent >= 1) {
            this.compareEl.textContent = this.formatter.format(compareTotal);
            this.compareEl.hidden = false;
          } else {
            this.compareEl.hidden = true;
          }
        }

        if (this.savingEl) {
          if (savingPercent >= 1) {
            const template = this.savingEl.dataset.template || 'Bespaar {procent}%';
            this.savingTextEl.textContent = template.replace('{procent}', savingPercent);
            this.savingEl.hidden = false;
          } else {
            this.savingEl.hidden = true;
          }
        }

        if (this.cta && this.ctaHref && this.ctaHref !== '#') {
          const selected = this.options.find((option) => option.checked);
          const url = new URL(this.ctaHref, window.location.href);

          url.searchParams.set('aantal', quantity);
          if (selected && selected.value) {
            url.searchParams.set('product', selected.value);
          } else {
            url.searchParams.delete('product');
          }

          const href = url.origin === window.location.origin
            ? url.pathname + url.search + url.hash
            : url.href;

          this.cta.setAttribute('href', href);
        }
      }
    }

    customElements.define('alygn-rekentool', AlygnRekentool);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werkplek-kaarten"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alygn-swipe')) {
    class AlygnSwipe extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-swipe-track]');
        this.dots = this.querySelector('[data-swipe-dots]');
        if (!this.track || !this.dots) return;

        this.items = Array.from(this.track.children).filter(function (child) {
          return child.tagName === 'LI';
        });

        this.build();
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }

      build() {
        var self = this;
        this.dots.innerHTML = '';
        this.buttons = this.items.map(function (item, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = self.dataset.dotClass || 'werkplek-kaarten__dot';
          button.setAttribute('aria-label', 'Ga naar item ' + (index + 1));
          button.addEventListener('click', function () {
            self.track.scrollTo({ left: item.offsetLeft - self.track.offsetLeft, behavior: 'smooth' });
          });
          self.dots.appendChild(button);
          return button;
        });
      }

      onScroll() {
        var swipeable = this.track.scrollWidth - this.track.clientWidth > 8;
        this.dots.hidden = !swipeable || this.items.length < 2;
        if (this.dots.hidden) return;

        var center = this.track.scrollLeft + this.track.clientWidth / 2;
        var active = 0;
        var self = this;
        this.items.forEach(function (item, index) {
          var start = item.offsetLeft - self.track.offsetLeft;
          if (start <= center) active = index;
        });

        this.buttons.forEach(function (button, index) {
          button.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
      }
    }

    customElements.define('alygn-swipe', AlygnSwipe);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zakelijk-usps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUsps(root) {
      if (root.dataset.uspsReady) return;

      var grid = root.querySelector('[data-usps-grid]');
      var dots = root.querySelector('[data-usps-dots]');
      if (!grid || !dots) return;

      var items = Array.prototype.slice.call(grid.children);
      if (items.length < 2) return;

      root.dataset.uspsReady = 'true';
      dots.innerHTML = '';

      var buttons = items.map(function (item, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'zakelijk-usps__dot';
        button.setAttribute('aria-label', 'Ga naar voordeel ' + (index + 1));
        button.addEventListener('click', function () {
          grid.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(button);
        return button;
      });

      var ticking = false;

      function update() {
        ticking = false;
        var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
        var active = 0;

        if (atEnd) {
          active = items.length - 1;
        } else {
          var smallest = Infinity;
          items.forEach(function (item, index) {
            var distance = Math.abs(item.offsetLeft - grid.scrollLeft);
            if (distance < smallest) {
              smallest = distance;
              active = index;
            }
          });
        }

        buttons.forEach(function (button, index) {
          if (index === active) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }

      grid.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }, { passive: true });

      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-zakelijk-usps]').forEach(initUsps);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
